import { colors } from '@mui/material';
import { icon } from 'leaflet';

export const ROUTES = {
  UCD_FULL_ROUTE_A: {
    missionId: '3a3eb2e8-9789-495f-b886-27de236a5eda',
    startPos: '53.30393055555555,-6.210436111111111',
    dropPos: '53.30370277777777,-6.212466666666667',
    endPos: '53.30393055555555,-6.210436111111111'
  },
  UCD_FULL_ROUTE_B: {
    missionId: 'e1aaefd7-9738-46a8-ab6a-bbff33fc1336',
    startPos: '53.30384166666666,-6.2102361111111115',
    dropPos: '53.30370277777777,-6.212466666666667',
    endPos: '53.30384166666666,-6.2102361111111115'
  },
  UCD_SHORT_ROUTE_A: {
    missionId: '58f9e102-e7cd-44e9-bc9d-4699ebe2e201',
    startPos: '53.30393055555555,-6.210436111111111',
    dropPos: '53.303327777777774,-6.211263888888889',
    endPos: '53.30393055555555,-6.210436111111111'
  },
  UCD_SHORT_ROUTE_B: {
    missionId: 'd564e09a-7517-4796-ba40-8dbd360ceb3c',
    startPos: '53.30384166666666,-6.2102361111111115',
    dropPos: '53.303327777777774,-6.211263888888889',
    endPos: '53.30384166666666,-6.2102361111111115'
  },
  UCD_SHORT_14M_ROUTE_A: {
    missionId: '4744d9dc-b324-47e4-b70e-45075803121c',
    startPos: '53.30393055555555,-6.210436111111111',
    dropPos: '53.303327777777774,-6.211263888888889',
    endPos: '53.30393055555555,-6.210436111111111'
  },
  UCD_SHORT_14M_ROUTE_B: {
    missionId: 'af5bf57d-8f3a-48da-93bc-267df72301ba',
    startPos: '53.30384166666666,-6.2102361111111115',
    dropPos: '53.303327777777774,-6.211263888888889',
    endPos: '53.30384166666666,-6.2102361111111115'
  }
};

export const apiKey = process.env.REACT_APP_API_KEY;
export const mannaApiHost = process.env.REACT_APP_MANNA_CORE_API_HOST;
export const dublinCoords = [53.274437, -6.269326];
export const blessingtonCoords = [53.176594939392544, -6.509968042373657];
export const moneygallCoords = [52.883703, -7.942364];
export const ballymoneyCoords = [52.940874877385795, -6.081990748643875];
export const walesCoords = [51.709083, -3.006929];
export const uskCoords = [51.710588, -2.8609375];
export const oranmoreCoords = [53.26943, -8.930513];
export const balbrigganCoords = [53.606475, -6.197206];
export const clonfertCoords = [53.2363267, -8.0972144];
export const moorockCoords = [53.3462485, -7.7155647];
export const kerryCoords = [52.252859,-10.023492];
export const blanchCoords = [53.392412, -6.395389];
export const blanchJ6Coords = [53.384164313744236, -6.364297282049989];
export const espooCoords = [60.16897573504341, 24.780146659668457];
export const espooTestSiteCoords = [60.48059091, 26.59558097];
export const pecanSquareCoords = [33.09246542236036, -97.2481172359254];
export const pecanSquareTestSiteCoords = [33.049016060747256, -97.29231000142107];
export const ouluCoords = [65.011914, 25.468495];
export const corkCentralCoords = [51.89812048, -8.45080341];

export const cellNameCoords = {
  ORANMORE: oranmoreCoords,
  BALBRIGGAN: balbrigganCoords,
  BELAIR: moorockCoords,
  BELAIR_OPS_SIM: moorockCoords,
  KERRY: kerryCoords,
  PECAN_SQUARE: pecanSquareCoords,
  PECAN_SQUARE_TEST_SITE: pecanSquareTestSiteCoords,
  BLANCHARDSTOWN: blanchCoords,
  BLANCHARDSTOWN_J6: blanchJ6Coords,
  ESPOO: espooCoords,
  ESPOO_TEST_SITE: espooTestSiteCoords,
  OULU: ouluCoords,
  CORK_CENTRAL: corkCentralCoords,
};

export const orderTrackingInterval =
  process.env.REACT_APP_ORDER_TRACKING_INTERVAL || 10;
export const webSocketEndpoint = 'wss://ws.manna.aero/';

export const requestOptions = {
  responseType: 'json'
};

export const inactiveStatuses = [
  'STORE_REJECTED',
  'STORE_UNAVAILABLE',
  'COMPLETE',
  'REJECTED',
  'CANCELLED',
  'ABORTED',
  'RESET',
  'COMPLETE_BYCAR',
  'DELIVERY_ISSUE',
  'FROM_RESET',
  'DELIVERED'
];

export const flyingStatuses = [
  'DISPATCHED', 'DELIVERED'
];

export const mannaColors = {
  red: '#fc4f00',
  green: '#2da343',
  yellow: '#ffe109',
  blue: {
    100: '#3f52b5',
    200: '#007ac3',
    300: '#049fd4'
  },
  purple: '#9933ff'
};

export const uavPermissions = {
  READ: 'READ',
  READ_WRITE: 'READ_WRITE'
};

export const telemStates = {
  OK: 1,
  WARN: 2,
  RTL: 3
};

export const performanceMetrics = {
  CPU_USAGE: 'total_cpu_usage',
  MEM_USAGE: 'total_mem_usage',
  DISK_USAGE: 'disk_usage',
  LOG_SIZE: 'log_size'
};

export const TAGS = [
  'TEAM1',
  'TEAM2',
  'TEAM3',
  'TEAM4',
  'TEAM5',
  'TEAM6',
  'TEAM7',
  'LANE1',
  'LANE2',
  'LANE3',
  'LANE4',
  'LANE5',
  'LANE6',
  'LANE7',
  'NEXT',
  'PREPARE',
  'PAUSE'
];

export const tagColours = {
  TEAM1: colors.blue[500],
  TEAM2: colors.lightGreen[500],
  TEAM3: colors.yellow[900],
  TEAM4: colors.pink[300],
  TEAM5: colors.blue[100],
  TEAM6: colors.green[500],
  TEAM7: colors.pink[900],
  NEXT: colors.red[500],
  PREPARE: colors.purple[400],
  PAUSE: colors.brown[400]
};

export const uavIconColours = {
  black: require('../assets/svgs/DroneBlackMap.svg'),
  blue: require('../assets/svgs/DroneBlueMap.svg'),
  yellow: require('../assets/svgs/DroneYellowMap.svg'),
  red: require('../assets/svgs/DroneRedMap.svg')
};

export const getUavImage = (uavState, flightMode, size) => {
  return icon({
    iconUrl: uavImageColours[getUavIcon(uavState, flightMode, false)],
    iconRetinaUrl: uavImageColours[getUavIcon(uavState, flightMode, false)],
    iconSize: [getSize(size), getSize(size)],
    iconAnchor: [getSize(size) / 2, getSize(size) / 2],
    shadowUrl: 'my-icon-shadow.png'
  });
};
export const uavColours = {
  black: colors.grey[500],
  blue: colors.blue[400],
  yellow: colors.yellow[900],
  red: colors.red[500]
};

export const uavImageColours = {
  black: require('../assets/images/MANNA_ARROW_BLACK.png'),
  blue: require('../assets/images/MANNA_ARROW_BLUE.png'),
  yellow: require('../assets/images/MANNA_ARROW_YELLOW.png'),
  red: require('../assets/images/MANNA_ARROW_RED.png'),
  green: require('../assets/images/MANNA_ARROW_GREEN.png')
};

const getSize = (size: 'small' | 'medium' | 'large') => {
  if (size === 'small') return 24;
  if (size === 'medium') return 28;
  if (size === 'large') return 48;
  return 24;
};

export const getUavIcon = (
  uavState: string,
  flightMode: string,
  isHovered: boolean
) => {
  if (isHovered) return 'yellow';
  if (uavState === 'MAINTENANCE') return 'black';
  if (uavState === 'STANDBY') return 'green';
  if (flightMode === 'AUTO') return 'blue';
  if (flightMode === 'POSHOLD') return 'blue';
  if (flightMode === 'LOITER') return 'blue';
  if (flightMode === 'GUIDED') return 'blue';
  if (flightMode === 'CMODE(27)') return 'red';
  return 'black';
};

export const getUavLIcon = (
  uavState: string,
  flightMode: string,
  isHovered: boolean,
  size: 'small' | 'medium' | 'large'
) => {
  return icon({
    iconUrl: uavImageColours[getUavIcon(uavState, flightMode, isHovered)],
    iconRetinaUrl: uavImageColours[getUavIcon(uavState, flightMode, isHovered)],
    iconSize: [getSize(size), getSize(size)],
    iconAnchor: [getSize(size) / 2, getSize(size) / 2],
    shadowUrl: 'my-icon-shadow.png'
  });
};

export const uavStateIcon = (uavState, stale, hovered) => {
  if (hovered) return uavIconColours.yellow;
  if (stale) return uavIconColours.black;
  if (uavState === 'STANDBY') {
    return uavIconColours.blue;
  } else if (uavState === 'MISSION') {
    return uavIconColours.blue;
  } else if (uavState === 'MAINTENANCE') {
    return uavIconColours.black;
  }

  return uavIconColours.black;
};

export const newTeamColour = (status: string) => {
  if (status === 'NEW') {
    return '#ED0505';
  } else if (status === 'ON_THE_WAY') {
    return '#FC5000';
  } else if (status === 'ARRIVED') {
    return '#EAAC30';
  } else if (status === 'DROP_SUGGESTED') {
    return '#EAAC30';
  } else if (status === 'DROP_SAFE'){
    return '#EAAC30';
  } else if (status === 'DROP_REJECTED') {
    return '#EAAC30';
  } else if (status === 'AWAITING_DROP') {
    return '#008A00';
  } else if (status === 'COMPLETE') {
    return '#A0A3BD';
  }
  return '#ED0505';
};

export const kerryCellId = 5;
export const blanchCellId = 7;
export const pecanSquareCellId = 8;
export const junction6CellId = 11;
export const dropPointRadiusInMetres = 4.5;
export const espooCellId = 12;
export const espooTestSiteCellId = 13;
export const ouluCellId = 17;

export const blanchZoneId = 'df11cb36-3129-4824-81bb-dd470cd21837';
